<template>
  <div class="headers">
    <div class="headNav">
      <div class="haedLogo">
        <img style="height: auto;" src="../assets/img/logo_head.png" />
      </div>
      <div class="headBut" @click="toggleMenu()">
        <img src="https://aliyunosszs.musicwow.com/APPimg/homeNav.png" />
      </div>
    </div>
    <div class="headShow" @click="toggleMenu()" v-show="headShow"></div>
    <ul class="head-list" v-show="headList">
      <li class="item" v-for="(item, index) in navList" :key="index">
        <div
          v-if="!item.children || item.children.length === 0"
          :class="`link ${$route.path == item.path ? 'active' : ''}`"
          @click="routeTo(item.path)"
        >
          {{ item.title }}
        </div>
        <div class="drawer" v-else>
          <div class="title" @click="toggleDrawer(index)">
            <span class="text">{{ item.title }}</span>
            <i v-show="item.open" class="icon el-icon-arrow-down"></i>
            <i v-show="!item.open" class="icon el-icon-arrow-up"></i>
          </div>
          <ul class="content" v-show="item.open">
            <li
              v-for="(it, idx) in item.children"
              :key="idx"
              :class="`link ${$route.path == it.path ? 'active' : ''}`"
              @click="routeTo(it.path)"
            >
              {{ it.title }}
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "headers",
  data() {
    return {
      headShow: false,
      headList: false,
      navList: [
        { title: "首页", id: 1, path: "/" },
        { title: "APP", id: 2, path: "/MusicwowApp" },
        // { title: "合伙人招募", id: 3, path: "/League" },
        {
          title: "课程产品",
          open: false,
          children: [
            { title: "音乐素养AI课", id: 5, path: "/initiation" },
            { title: "课程体系", id: 4, path: "/Teaching" },
          ],
        },
        { title: "管理系统", id: 6, path: "/Admin" },
        { title: "乐器课程", id: 7, path: "/Musicwow" },
        {
          title: "关于我们",
          open: false,
          children: [
            { title: "公司简介", id: 8, path: "/Company" },
            { title: "品牌动态", id: 9, path: "/Dynamic" },
            { title: "联系我们", id: 10, path: "/Contact" },
            { title: "加入我们", id: 11, path: "/Joinus" },
          ],
        },
      ],
    };
  },
  created() {
    let path = this.$route.path;
    this.navList.map((item) => {
      if (item.children && item.children.length > 0) {
        let target = item.children.findIndex((it) => {
          return it.path === path;
        });
        if (target >= 0) {
          item.open = true;
        }
      }
    });
  },
  methods: {
    toggleMenu() {
      this.headShow = !this.headShow;
      this.headList = !this.headList;
    },
    toggleDrawer(index) {
      this.navList[index].open = !this.navList[index].open;
    },
    routeTo(path) {
      this.$router.push({
        path: path,
      });
    },
  },
};
</script>
<style lang="sass" scoped>
.headers
  width: 100%
  .headNav
    display: flex
    width: 100%
    height: 60px
    font-size: 18px
    background: #fff
    position: fixed
    z-index: 668
    .haedLogo
      img
        width: 104px !important
        margin-top: 12px
        margin-left: 10px
    .headBut
      margin-left: auto
      line-height: 60px
      img
        width: 14px !important
        height: 11px
        margin-right: 10px
  .headShow
    width: 100%
    height: 100%
    background: rgba(0,0,0,0.2)
    position: fixed
    z-index: 33
    top: 0
  .head-list
    position: fixed
    z-index: 555
    background: #fff
    padding: 30px
    width: 100px
    height: 100%
    right: 0
    top: 30px
    text-align: left
    color: rgba(0,0,0,0.5)
    font-size: 14px
    .item
      &:first-child
        .link
          border-top: 0
    .link
      padding: 10px 0
      border-top: 1px solid rgba(158, 158, 158, 0.5)
      &.active
        color: #07D1AA
    .drawer
      .title
        border-top: 1px solid rgba(158, 158, 158, 0.5)
        padding: 10px 0
        display: flex
        .text
          flex: 1
        .icon
          margin-top: 4px
      .content
        padding-top: 10px
        .link
          color: #999
          font-size: 12px
          border-color: hsla(0,0%,62%,.2)
          padding: 10px 0
          &.active
            color: #07D1AA
          &:first-child
            border-top: 0
</style>

